<template>
   <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin pt-4">
        <!-- タイトル -->
        <div class="text-center">
            <h3>{{ $t('hec.ConditionRenewal.title') }}</h3>
        </div>
        <!--　メッセージ -->
        <div class="text-center text-message" v-html="$t('hec.ConditionRenewal.message')"></div>
        
        <!-- 申込条件 -->
        <div class="box">
            <div class="wrap">
                <div class="condition">
                    <div>
                        <div>{{ $t('hec.ConditionRenewal.condition') }}</div>
                    </div>
                </div>
            </div> 
        </div>
        <div class="box">
            <div class="wrap">
                <div class="condition">
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionPoint') }}</span>
                    </div>
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage1') }}</span>
                    </div>
                </div>
            </div> 
        </div>
        <div class="box">
            <div class="wrap">
                <div class="condition asterisk-bottom">
                    <div>
                        <span class="asterisk">{{ $t('hec.ConditionRenewal.conditionASTERISK') }}</span>
                    </div>
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage8') }}</span>
                    </div>
                </div>
            </div> 
        </div>
        <div class="box">
            <div class="wrap">
                <div class="condition">
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionPoint') }}</span>
                    </div>
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage2') }}</span>
                    </div>
                </div>
            </div> 
        </div>
        <div class="box num">
            <div class="wrap">
                <div class="condition">
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionNum1') }}</span>
                    </div>
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage3') }}</span>
                    </div>
                </div>
                <div class="condition">
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionNum2') }}</span>
                    </div>
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage4') }}</span>
                    </div>
                </div>
            </div> 
        </div>
        <div class="box num">
            <div class="wrap">
                <div class="condition">
                    <div>
                        <span>{{ $t('hec.ConditionRenewal.conditionMessage9') }}</span>
                    </div>
                </div>
            </div> 
        </div>
        <div class="text-center">
            <div class="box text-center">
                <div class="wrap">
                    <div class="condition-hec">
                        <div>
                            <!-- HEC Saving申込実績 HEC -->
                            <div class="label">{{ $t('hec.ConditionRenewal.conditionMessage5') }}</div>
                            <div id="col" class="text-hec1">{{ this.deposited_hec }}{{ $t('hec.ConditionRenewal.conditionMessage7') }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <div class="box text-center">
                <div class="wrap">
                    <div class="condition-hec">
                        <div>
                            <!-- フォルシングキャンペーン　EX Bonus HEC -->
                            <div class="label">{{ $t('hec.ConditionRenewal.conditionMessage6') }}</div>
                            <div class="text-hec2">{{ this.required_hec  }}{{ $t('hec.ConditionRenewal.conditionMessage7') }}</div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center">
            <!-- 注意事項 -->
            <div class="text-center text-message" v-html="$t('hec.ConditionRenewal.notesMessage')"></div>
        </div>

        <div class="text-center">
            <form @submit.prevent="handleOnSubmit">
                
                <div class="form-row py-3 justify-content-center">
                    <!-- キャンセルボタン -->
                    <div class="col-md-4">
                        <router-link :to="{ name: 'messages' }" class="text-center">
                            <span class="btn btn-light btn-block">{{ $t('hec.policy.cancelButton') }}</span>
                        </router-link>
                    </div>
                    <!-- 次へボタン -->
                    <div class="col-md-4 mt-2 mt-md-0">
                        <button type="submit" class="btn btn-primary btn-block">{{ $t('hec.policy.nextButton') }}</button>
                    </div>
                </div>

            </form>      
        </div>

        <!-- エラーメッセージ -->
        <div v-if="this.display">
            <div class="text-center text-errorMessage" v-html="$t('hec.ConditionRenewal.errorMessage')"></div>
        </div>
    </div>
</template>

<script>
    import UserService from '../../services/UserService'
    import BN from 'bignumber.js'
    import { HEC_DEFAULT, HEC_COLOR_RED } from '../../utils/Const';
    
    export default {
        name: 'MembershipFeeConditionRenewal',

        components: {
        },
        
        data() {
            return {
                required_hec: '',
                deposited_hec: '',
                required_hec_round_up: '',
                deposited_hec_round_up: '',
                can_apply: false,

                display: false,
            }
        },

        async created() {
        },

        mounted() {  
            this.fetch()
        },

        methods: {
            async handleOnSubmit() {
                if (this.can_apply) {
                    this.$router.push('/membership/policy-renewal')
                } else {
                    //エラー文言表示
                    this.display = true
                }
            },
            async fetch() {

                const result = await UserService.getHecSavingApplyInfo()

                //申し込み条件を満たしているかどうか判定
                this.can_apply = result.data.can_apply
                
                BN.set({ROUNDING_MODE:BN.ROUND_UP})

                //HEC Saving 申込実績HEC
                this.deposited_hec_round_up = (new BN(result.data.deposited_hec)).toFixed(8);

                //フォルシングキャンペーン　EX Bonus HEC
                this.required_hec_round_up = (new BN(result.data.required_hec)).toFixed(8);

                if(this.deposited_hec_round_up == 0) {
                    this.deposited_hec = HEC_DEFAULT
                } else {
                    this.deposited_hec = this.deposited_hec_round_up
                }
                
                if(this.required_hec_round_up == 0) {
                    this.required_hec = HEC_DEFAULT
                } else {
                    this.required_hec = this.required_hec_round_up
                }

                if ( !this.can_apply ) {
                    //HEC Saving 申込実績HEC 赤文字表示
                    document.getElementById("col").style.color = HEC_COLOR_RED
                }
            },
        },
        computed: {
        }
    }
</script>

<style scoped>
    @import "~vodal/common.css";
    @import "~vodal/slide-down.css";
    .text-condition{
        margin-top: 20px;
    }
    .text-message{
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .label{
        margin-top: 20px;
        text-align: left;
    }
    .text-hec1{
        margin-left: 5%;
        margin-right: 5%;
        padding: 10px;
        border: solid 1px;
        word-wrap: break-word;
    }
    .text-hec2{
        margin-left: 5%;
        margin-right: 5%;
        padding: 10px;
        border: solid 1px;
        word-wrap: break-word;
    }
    .text-condition{
        margin-top: 10px;
    }
    .text-errorMessage{
        margin-top: 20px;
        color: #e3342f;
    }
    .box {
        text-align:left;
        border-top-width: 0px;
    }
    .num{
        padding-left: 30px;
    }
    .wrap {
        margin-left: auto;
    }
    .condition {
        width: 100%;
        display: flex;
        max-width: 360px;
        margin: 0 auto;
    }
    .condition-hec {
        width: 100%;
        max-width: 360px;
        margin: 0 auto;
    }
    .asterisk {
        margin-left: 15px;
    }
    .asterisk-bottom {
        margin-bottom: 15px;
    }

    .btn:hover {
        color: #fff !important;
    }
   
    @media screen and (min-width: 478px) {
        .num{
            padding-left: 60px;
        }
    }
</style>
